import useChatStore from "./store";

export default useChatStore;
